export default "__VITE_ASSET__CvltD$ce__"